import { render, staticRenderFns } from "./MessageManagePage.vue?vue&type=template&id=3cf5f0d8&scoped=true&"
import script from "./MessageManagePage.vue?vue&type=script&lang=js&"
export * from "./MessageManagePage.vue?vue&type=script&lang=js&"
import style0 from "./MessageManagePage.vue?vue&type=style&index=0&id=3cf5f0d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf5f0d8",
  null
  
)

export default component.exports